export const getProductVariant = (productId?: string): 'Med veihjelp' | 'Uten veihjelp' | undefined => {
  if (!productId) return undefined;

  const withRoadsideAssistance = ['1111', '1141', '1605', '6111'];
  const withoutRoadsideAssistance = ['1121', '1131', '1601', '6020'];

  if (withRoadsideAssistance.includes(productId)) {
    return 'Med veihjelp';
  }

  if (withoutRoadsideAssistance.includes(productId)) {
    return 'Uten veihjelp';
  }

  return undefined;
};
